// Styling
import style from "./container.module.scss";

export default function Container(props) {
  // Variables
  const attributes = props.atts;
  let classes = "container";

  let width = props.width ?? false;
  const containerStyle = width
    ? "container" + width.charAt(0).toUpperCase() + width.slice(1)
    : "";

  classes += props.className ? " " + props.className : "";
  classes += style.container ? " " + style.container : "";
  if (containerStyle && typeof style[containerStyle] !== "undefined") {
    classes += " " + style[containerStyle];
  }

  return (
    <div className={`${classes}`} {...attributes}>
      {props.children}
    </div>
  );
}
